import Link from "next/link";
import { useSelector } from "react-redux";

import styles from "./index.module.scss";

function stripHtml(html) {
  if (!html || typeof html !== "string") return "";
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function trackPhoneClick() {
  if (typeof window === "undefined") return;

  if (
    window.location.href.includes(
      "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_moskve",
    )
  ) {
    if (typeof ym !== "undefined") {
      // eslint-disable-next-line no-undef
      ym(20518312, "reachGoal", "mskRegPhoneClick");
    }
  } else if (
    window.location.href.includes(
      "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_sankt-peterburge",
    )
  ) {
    if (typeof ym !== "undefined") {
      // eslint-disable-next-line no-undef
      ym(20518312, "reachGoal", "spbRegPhoneClick");
    }
  }
}

/** Контакты в подвале с microdata LocalBusiness. Снаружи — только href логотипа. */
export default function FooterLocalBusinessContacts({ logoHref = "/" }) {
  const { contacts, shops, domainData } = useSelector(
    (state) => state.contacts,
  );
  const { cityName } = useSelector((state) => state.location);

  const shop = shops?.[0];
  const phone = contacts?.phone || shop?.phone;
  const email = contacts?.email || "info@farkop.ru";
  const city = cityName || domainData?.name || domainData?.declension || "";
  const streetAddress = stripHtml(shop?.address);
  const hasAddress = streetAddress || city;

  return (
    <div
      className={styles.Root}
      itemScope
      itemType="https://schema.org/LocalBusiness"
    >
      <Link href={logoHref}>
        <a className={styles.Logo}>
          <img src="/logo3.svg" alt="Farkop.ru" />
        </a>
      </Link>

      {hasAddress && (
        <address className={styles.Address}>
          <span itemProp="name">Farkop.ru</span>
          <br />
          <span
            itemProp="address"
            itemScope
            itemType="https://schema.org/PostalAddress"
          >
            <span itemProp="addressCountry">Россия</span>
            {city && (
              <>
                , <span itemProp="addressLocality">{city}</span>
              </>
            )}
            <br />
            {streetAddress && (
              <span itemProp="streetAddress">{streetAddress}</span>
            )}
          </span>
          <br />
        </address>
      )}
      {!hasAddress && <span itemProp="name">Farkop.ru</span>}

      {phone && (
        <a
          href={`tel:${phone}`}
          className={contacts?.calltouchCode}
          itemProp="telephone"
          onClick={trackPhoneClick}
        >
          {phone}
        </a>
      )}
      {email && (
        <a href={`mailto:${email}`} itemProp="email">
          {email}
        </a>
      )}
    </div>
  );
}
